//chats---------------------------------------------------
export const ADD_NEW_CONVERSATION = "ADD_NEW_CONVERSATION";
export const NEW_SERVER_MESSAGE_RECEIVED = "NEW_SERVER_MESSAGE_RECEIVED";
export const ARCHIVED_MESSAGES_RECEIVED = "ARCHIVED_MESSAGES_RECEIVED";
export const CHANGE_SELECTED_CONVERSATION = "CHANGE_SELECTED_CONVERSATION";
export const RESET_CHAT_REDUCER = "RESET_CHAT_REDUCER";
export const REMOVE_TABLE_MESSAGE = "REMOVE_TABLE_MESSAGE"
export const REMOVE_AUTHORIZATION_REQUEST = "REMOVE_AUTHORIZATION_REQUEST"
export const CLEAR_CHATWIDGET_NOTIFICATIONS = "CLEAR_CHATWIDGET_NOTIFICATIONS"
export const UPDATE_CHATWIDGET_NOTIFICATIONS = "UPDATE_CHATWIDGET_NOTIFICATIONS"
export const CLEAR_URL_CONTENT = "CLEAR_URL_CONTENT"
export const CLEAR_BOTCALL_CONTENT = "CLEAR_BOTCALL_CONTENT"
export const UPDATE_USER_DOMAIN_ROLES = "UPDATE_USER_DOMAIN_ROLES"
export const CLEAR_PRINT_SCREEN_CHECK = "CLEAR_PRINT_SCREEN_CHECK"
export const GET_FAVOURITES = "GET_FAVOURITES";
export const SELECTED_GROUP_CHAT = "SELECTED_GROUP_CHAT";
export const SELECTED_GROUP_CHAT_PARTICIPANTS = "SELECTED_GROUP_CHAT_PARTICIPANTS";
export const SET_ONE_TO_ONE_CHAT = "SET_ONE_TO_ONE_CHAT";
export const TOGGLE__FAVORITE_CONVERSATION = "TOGGLE__FAVORITE_CONVERSATION";
export const SELECTED_CONTACT_DATA = "SELECTED_CONTACT_DATA";
export const HIDE_CHATWIDGET_NOTIFICATION = "HIDE_CHATWIDGET_NOTIFICATION";
export const CLEAR_SELECTED_CONVERSATION = "CLEAR_SELECTED_CONVERSATION"
export const GENERATING_PUSH_NOTIFICATIONS = "GENERATING_PUSH_NOTIFICATIONS"
export const DE_GENERATING_PUSH_NOTIFICATIONS = "DE_GENERATING_PUSH_NOTIFICATIONS"

//chatInWindow
export const SET_CHAT_IN_WINDOW = "SET_CHAT_IN_WINDOW";
export const SET_INITIALIZE_CHAT_IN_WINDOW = "SET_INITIALIZE_CHAT_IN_WINDOW";


//filter 

export const RENDER_NONCONVERSATIONAL_FILTER = "RENDER_NONCONVERSATIONAL_FILTER";
export const UPDATE_NONCONVERSATIONAL_FILTERS = "UPDATE_NONCONVERSATIONAL_FILTERS";
export const SET_ADD_MANUALLY_ROW = "SET_ADD_MANUALLY_ROW";

//domain ---------------------------------------
export const DOMAIN_RECEIVED = "DOMAIN_RECEIVED";
export const SELECTED_DOMAIN = "SELECTED_DOMAIN";
export const UPDATE_DOMAIN = "UPDATE_DOMAIN";
export const REMOVE_SELECTED_DOMAIN = "REMOVE_SELECTED_DOMAIN";
export const SET_DOMAIN_STATE = 'SET_DOMAIN_STATE'


//loader-----------------------------------------
export const BOT_WAIT_LOADER = "BOT_WAIT_LOADER";
export const BOT_WAIT_LOADER_WITH_SHIMMER = "BOT_WAIT_LOADER_WITH_SHIMMER";
export const SEARCH_LOADER = "SEARCH_LOADER";
export const BUTTON_LOADER = "BUTTON_LOADER";
export const SET_LOADER = "SET_LOADER";


//modal-----------------------------------------
export const SHOW_TAB_CLOSE_MODAL = "SHOW_TAB_CLOSE_MODAL";
export const HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL = "HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL";


//user-------------------------------------------
export const BOT_SUBSCRIPTIONS_RECEIVED = "BOT_SUBSCRIPTIONS_RECEIVED";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_PROFILE_IMAGE = "USER_PROFILE_IMAGE";
export const UPDATE_USER = "UPDATE_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_LOGGED_IN_USER_CALL_HISTORY = "UPDATE_LOGGED_IN_USER_CALL_HISTORY";
export const CLEAR_LOGGED_IN_USER_CALL_HISTORY = "CLEAR_LOGGED_IN_USER_CALL_HISTORY";
export const UPDATE_SELECTED_CONTACT_CALL_HISTORY = "UPDATE_SELECTED_CONTACT_CALL_HISTORY";
export const UPDATE_PHONE_BALANCE = "UPDATE_PHONE_BALANCE";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const VOIP_STATUS = "VOIP_STATUS";
export const LICENSE_STATUS = "LICENSE_STATUS";
export const UPDATE_CALL_HISTORY = "UPDATE_CALL_HISTORY";
export const USER_ONLINE_STATUS = "USER_ONLINE_STATUS";

//tabStack---------------------------------------
export const TAB_CHANGE = "TAB_CHANGE";
export const RENDER_MESSAGE_TYPE_TABLE = "RENDER_MESSAGE_TYPE_TABLE";
export const RENDER_MESSAGE_TYPE_CONTAINER = "RENDER_MESSAGE_TYPE_CONTAINER";
export const CHANGE_CONTAINER_SELECTED_TAB = "CHANGE_CONTAINER_SELECTED_TAB";
export const RENDER_MESSAGE_TYPE_FORM2 = "RENDER_MESSAGE_TYPE_FORM2";
export const RENDER_MESSAGE_TYPE_VIDEOCALL = "RENDER_MESSAGE_TYPE_VIDEOCALL";
export const RENDER_MESSAGE_TYPE_MENU = "RENDER_MESSAGE_TYPE_MENU";
export const RENDER_MESSAGE_TYPE_MAP = "RENDER_MESSAGE_TYPE_MAP";
export const RENDER_MESSAGE_TYPE_CALENDAR = "RENDER_MESSAGE_TYPE_CALENDAR";
export const RENDER_MESSAGE_TYPE_HTML = "RENDER_MESSAGE_TYPE_HTML";
export const RENDER_MESSAGE_TYPE_TIMELINE = "RENDER_MESSAGE_TYPE_TIMELINE";
export const RENDER_MESSAGE_TYPE_CHAT = "RENDER_MESSAGE_TYPE_CHAT";
export const RENDER_MESSAGE_TYPE_SURVEY = "RENDER_MESSAGE_TYPE_SURVEY";
export const RENDER_MESSAGE_TYPE_DASHBOARD = "RENDER_MESSAGE_TYPE_DASHBOARD";
export const CHANGE_CALENDAR = "CHANGE_CALENDAR";
export const RESET_FORM2_FIELDS = "RESET_FORM2_FIELDS";
export const RESET_CONTAINER_FIELDS = "RESET_CONTAINER_FIELDS";
export const REMOVE_TAB = "REMOVE_TAB";
export const RESET_NONCONVENTIONAL = "RESET_NONCONVENTIONAL";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const BG_CALENDAR_TOOLBAR = "BG_CALENDAR_TOOLBAR";
export const SAVE_MAP_SETTINGS = "SAVE_MAP_SETTINGS";
export const RENDER_MESSAGE_TYPE_VIDOEPLAYER = "RENDER_MESSAGE_TYPE_VIDOEPLAYER";
export const RESET_TAB_STACK = "RESET_TAB_STACK"
export const REMOVE_PULL_DOWN_MENU = "REMOVE_PULL_DOWN_MENU"
export const TAB_STATE_CHANGE = "TAB_STATE_CHANGE"


//notifications------------------------------
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const RENDER_NOTIFICATION = "RENDER_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const RING_START = "RING_START";
export const RING_STOP = "RING_STOP";
export const SHOW_NOTIFICATION_POP_UP = "SHOW_NOTIFICATION_POP_UP";

//Chatwidget---------------------------------
export const SHOW_CHATWIDGET = "SHOW_CHATWIDGET"
export const HIDE_CHATWIDGET = "HIDE_CHATWIDGET"
export const SET_IMESSAGE_CHAT_ACTIVE_AREA = "SET_IMESSAGE_CHAT_ACTIVE_AREA";
export const SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL = "SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL";

//layout-------------------------------------
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const HIDE_SIDEBAR = "HIDE_SIDEBAR";
export const TOOGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_HEADER_TITLE = "SET_HEADER_TITLE";

//bot
export const SELECTED_BOT = "SELECTED_BOT";
export const REMOVE_BOT = "REMOVE_BOT";
export const OPEN_ASSISTATNT_BOT = "OPEN_ASSISTATNT_BOT";
export const HIDE_ASSISTATNT_BOT = "HIDE_ASSISTATNT_BOT";
export const SHOW_DEFAULT_HOME_PAGE_BOT = "SHOW_DEFAULT_HOME_PAGE_BOT";
export const HIDE_DEFAULT_HOME_PAGE_BOT = "HIDE_DEFAULT_HOME_PAGE_BOT";
export const SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT = "SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT";
export const SET_CLEAR_CACHE_FOR_SPINNET_BOT = "SET_CLEAR_CACHE_FOR_SPINNET_BOT";

//contacts

export const NEW_CONTACT_ACCEPT_IGNORE_MESSAGE__RECEIVED = "NEW_CONTACT_ACCEPT_IGNORE_MESSAGE__RECEIVED";
export const CONTACT_ACCEPTED = "CONTACT_ACCEPTED";
export const TRACK_FAVORITE_ACTION_PROGRESS = "TRACK_FAVORITE_ACTION_PROGRESS"
export const CLEAR_ACCEPT_IGNORE_CONTACT = "CLEAR_ACCEPT_IGNORE_CONTACT";
export const TIME_LINE_RECEIVED = "TIMELINE_RECEIVED";
export const UPDATE_TIME_LINE = "UPDATE_TIMELINE";
export const STANDDARD_NOTI_MSG = "STANDDARD_NOTI_MSG";
//settings--------------------------------------------
export const UPDATE_SOFTWARE_MFA = "UPDATE_SOFTWARE_MFA";
export const UPDATE_SOFTWARE_MFA_STATUS = "UPDATE_SOFTWARE_MFA_STATUS";
export const UPDATE_MFA_STATUS = "UPDATE_MFA_STATUS";
export const UPDATE_QR_CODE_URI = "UPDATE_QR_CODE_URI";

//socket ----------------------------------------------
export const INITIALIZE_SOCKET = "INITIALIZE_SOCKET";
export const WITHOUT_INIT_SOCKET = "WITHOUT_INIT_SOCKET";


//Thuraya domain name constants
export const THURAYA_DOMAIN_NAMES = [
	"Thuraya Test",
	"T2M",
	"T2M Test",
	"THURAYA",
	"THURAYA TRACKER",
	"Thuraya Staging"
];